var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box box--dashboardBlock"},[_c('div',{staticClass:"box__inner"},[_c('div',{staticClass:"dashboardBlock",class:'dashboardBlock--' + _vm.dashboardType},[_c('DashboardSidebar',{attrs:{"type":_vm.dashboardType}}),_c('div',{staticClass:"dashboardBlock__content"},[_c('router-view')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }